export default __webpack_public_path__ + "static/media/fridge2-beforeA-768w.f434b503.png";